// Social screens' copy in German (the Dutch in lib/social/copy.ts is the source), in our own words.
export const socialHubDe = {
  "social.about.section.account": "Konto",
  "social.about.sync.title": "Deine Notizen immer dabei",
  "social.about.sync.action": "Anmelden",
  "social.about.sync.manage": "Verwalten",
  "social.about.sync.signedInAs": "Angemeldet als {email}",
  "social.about.sync.unconfirmed":
    "Wir konnten dein Konto gerade nicht prüfen; du bleibst angemeldet und wir versuchen es gleich noch einmal.",
  "social.signin.gate.title": "Melde dich an, um gemeinsam zu verkosten",
  "social.signin.gate.body":
    "Freunde, Gruppen und Verkostungen gehören zu einem Konto. Deine Notizen auf diesem Gerät bleiben deine.",
  "social.signin.gate.action": "Anmelden",
  "social.about.public.label": "Erreichbar für Nachrichten an „alle“",
  "social.about.public.hint":
    "Schalte das ein, damit Freunde außerhalb deiner Gruppen dich in einer Verkostung mit einer Nachricht an „alle“ erreichen können. Das regelt nur, wer dir Nachrichten an alle senden darf, nicht ob du in der Suche gefunden wirst. Das steuerst du unter „Andere können dich finden“.",
  "social.about.discoverable.label": "Andere können dich finden",
  "social.about.discoverable.hint":
    "Dein Benutzername und dein Name sind für andere Nutzer durchsuchbar. Schalte das aus, um nicht gefunden zu werden.",
  "social.signin.title": "Anmelden",
  "social.signin.subtitle": "Wähle, wie du dich anmelden möchtest",
  "social.signin.provider.google": "Google",
  "social.signin.provider.microsoft": "Microsoft",
  "social.signin.provider.instagram": "Instagram",
  "social.signin.provider.tiktok": "TikTok",
  "social.signin.provider.pending": "Noch nicht verfügbar – wird vom Anbieter geprüft",
  "social.signin.error.denied": "Die Anmeldung wurde abgebrochen oder abgelehnt.",
  "social.signin.error.generic": "Die Anmeldung hat nicht geklappt. Versuche es noch einmal.",
  "social.signin.success.title": "Angemeldet",
  "social.friends.title": "Freunde",
  "social.friends.empty.title": "noch keine Freunde",
  "social.friends.empty.body": "Füge einen Freund hinzu, um gemeinsam zu verkosten.",
  "social.friends.empty.action": "Freund hinzufügen",
  "social.friends.incoming.title": "Anfragen",
  "social.friends.incoming.accept": "Annehmen",
  "social.friends.incoming.decline": "Ablehnen",
  "social.friends.outgoing.label": "Anfrage gesendet",
  "social.friends.outgoing.cancel": "Anfrage zurückziehen",
  "social.friends.row.block": "Blockieren",
  "social.friends.row.unblock": "Blockierung aufheben",
  "social.friends.row.remove": "Entfernen",
  "social.friends.accepted.toast": "Ihr seid jetzt Freunde",
  "social.friends.add.title": "Freund hinzufügen",
  "social.friends.add.searchPlaceholder": "Name oder Benutzername",
  "social.friends.add.send": "Anfrage senden",
  "social.friends.add.queued": "Wird gesendet, sobald du wieder online bist",
  "social.friends.add.sent": "Gesendet",
  "social.friends.add.noResults": "Keine Ergebnisse",
  "social.friends.add.action": "Hinzufügen",
  "social.friends.search.resultCount": "{n} Ergebnisse",
  "social.groups.title": "Gruppen",
  "social.groups.empty.title": "noch keine Gruppen",
  "social.groups.empty.body": "Lege eine Gruppe an, um gemeinsam zu verkosten.",
  "social.groups.empty.action": "Gruppe anlegen",
  "social.groups.memberCount": "{n} Mitglieder",
  "social.groups.role.owner": "Eigentümer",
  "social.groups.role.admin": "Admin",
  "social.groups.role.member": "Mitglied",
  "social.groups.create.title": "Gruppe anlegen",
  "social.groups.create.name": "Name",
  "social.groups.create.description": "Beschreibung (optional)",
  "social.groups.create.confirm": "Anlegen",
  "social.groups.edit.title": "Gruppe bearbeiten",
  "social.groups.edit.confirm": "Speichern",
  "social.groups.avatar.upload": "Foto wählen",
  "social.groups.avatar.uploading": "Wird hochgeladen…",
  "social.groups.avatar.remove": "Foto entfernen",
  "social.groups.visibility.label": "Wer kann diese Gruppe sehen",
  "social.groups.visibility.membersAndInvitees": "Sichtbar für Mitglieder und Eingeladene",
  "social.groups.visibility.membersOnly": "Nur Mitglieder, keine Linkvorschau",
  "social.groups.visibility.discoverable": "Sichtbar im Gruppenverzeichnis",
  "social.groups.directory.entry": "Gruppe suchen",
  "social.groups.directory.title": "Gruppe suchen",
  "social.groups.directory.searchPlaceholder": "Name der Gruppe",
  "social.groups.directory.noResults": "Keine Gruppen gefunden",
  "social.groups.directory.resultCount": "{n} Ergebnisse",
  "social.groups.directory.requestToJoin": "Beitritt anfragen",
  "social.groups.directory.requested": "Angefragt",
  "social.groups.joinRequests.title": "Beitrittsanfragen",
  "social.groups.joinRequests.accept": "Annehmen",
  "social.groups.joinRequests.decline": "Ablehnen",
  "social.groups.invitePermission.label": "Wer darf einladen",
  "social.groups.invitePermission.ownerAdmin": "Nur Eigentümer und Admins",
  "social.groups.invitePermission.anyMember": "Jedes Mitglied",
  "social.groups.detail.editAction": "Gruppe bearbeiten",
  "social.groups.detail.removeMember": "Entfernen",
  "social.groups.detail.leave": "Gruppe verlassen",
  "social.groups.detail.delete": "Gruppe löschen",
  "social.groups.detail.loadMore": "Mehr anzeigen",
  "social.groups.detail.zeroOwnerLeaveBlocked":
    "Übertrage zuerst das Eigentum oder lösche die Gruppe",
  "social.groups.invite.title": "Einladen",
  "social.groups.invite.noFriends": "Keine Freunde zum Einladen.",
  "social.session.title": "Verkostung",
  "social.session.draft.nameLabel": "Name",
  "social.session.draft.invite": "Einladen",
  "social.session.draft.startNow": "Jetzt starten",
  "social.session.scheduled.label": "Geplant für {date}",
  "social.session.action.schedule": "Planen",
  "social.session.action.start": "Starten",
  "social.session.action.cancel": "Absagen",
  "social.session.action.end": "Beenden",
  "social.session.status.invited": "eingeladen",
  "social.session.status.joined": "dabei",
  "social.session.status.online": "online",
  "social.session.status.offline": "offline",
  "social.session.status.live": "Live",
  "social.session.ended.title": "Beendet",
  "social.session.ended.toast": "diese Verkostung ist beendet",
  "social.session.reconnecting": "Verbindung wird wiederhergestellt…",
  "social.session.presenceCount": "{n} online",
  "social.session.schedule.date": "Datum (optional)",
  "social.session.schedule.time": "Uhrzeit (optional)",
  "social.session.schedule.invalid": "Wähle ein Datum und eine Uhrzeit in der Zukunft.",
  "social.session.invite.title": "Teilnehmende einladen",
  "social.session.invite.confirm": "Einladen",
  "social.session.invite.sourceFriends": "Freunde",
  "social.session.invite.sourceGroup": "Gruppe",
  "social.broadcast.composer.title": "Nachricht senden",
  "social.broadcast.composer.targetFriends": "Freunde",
  "social.broadcast.composer.targetGroup": "Gruppe",
  "social.broadcast.composer.targetEveryone": "Alle in dieser Verkostung",
  "social.broadcast.composer.textPlaceholder": "Deine Nachricht…",
  "social.broadcast.composer.send": "Senden",
  "social.broadcast.composer.queued": "Wird gesendet, sobald du wieder online bist",
  "social.broadcast.composer.sent": "Gesendet",
  "social.broadcast.composer.sentPartial": "Gesendet, {n} nicht zugestellt",
  "social.broadcast.panel.title": "An dich gerichtet in dieser Verkostung",
  "social.broadcast.panel.empty": "In dieser Verkostung ist noch nichts an dich gerichtet",
  "social.presence.online": "online",
  "social.presence.offline": "offline",
  "social.invite.friends.action": "Einladen",
  "social.invite.friends.title": "Freunde einladen",
  "social.invite.friends.lead":
    "Schicke deinen persönlichen Link. Wer ihn öffnet und sich anmeldet, wird dein Freund.",
  "social.invite.group.title": "In {group} einladen",
  "social.invite.group.lead": "Wer den Link öffnet oder den Code eintippt, kommt in die Gruppe.",
  "social.invite.channel.whatsapp": "WhatsApp",
  "social.invite.channel.email": "E-Mail",
  "social.invite.channel.sms": "SMS",
  "social.invite.channel.copy": "Link kopieren",
  "social.invite.channel.copied": "Link kopiert",
  "social.invite.qr.label": "QR-Code mit der Einladung",
  "social.invite.code.label": "Oder nenne diesen Code",
  "social.invite.code.until": "Gültig bis {time}",
  "social.invite.status": "Noch {left} von {max} Mal nutzbar, gültig bis {date}",
  "social.invite.audience.one": "Eine Person",
  "social.invite.audience.many": "Bis zu 10 Personen",
  "social.invite.audience.manyHint": "Bei mehr Personen bestätigst du jede Anfrage.",
  "social.invite.approval.label": "Neue Mitglieder zuerst freigeben",
  "social.invite.joined.title": "Wer dabei war",
  "social.invite.revoke": "Link widerrufen",
  "social.invite.revoked": "Dieser Link funktioniert nicht mehr.",
  "social.invite.renew": "Neuen Link erstellen",
  "social.invite.landing.title": "Einladung",
  "social.invite.landing.friend": "{name} lädt dich ein, gemeinsam zu verkosten.",
  "social.invite.landing.group": "{name} lädt dich in {group} ein.",
  "social.invite.landing.groupHidden": "{name} lädt dich in eine Gruppe ein.",
  "social.invite.landing.approval": "Ein Admin gibt deine Anfrage frei.",
  "social.invite.landing.expires": "Gültig bis {date}",
  "social.invite.landing.accept": "Annehmen",
  "social.invite.landing.decline": "Nein, danke",
  "social.invite.landing.signIn": "Anmelden, um anzunehmen",
  "social.invite.landing.gone.title": "Diese Einladung funktioniert nicht mehr",
  "social.invite.landing.gone.body": "Bitte um einen neuen Link oder Code.",
  "social.invite.landing.none.title": "Keine Einladung gefunden",
  "social.invite.landing.none.body": "Öffne den Link noch einmal oder tippe den Code ein.",
  "social.invite.outcome.friends": "Ihr seid jetzt Freunde",
  "social.invite.outcome.requested": "Anfrage gesendet. {name} bestätigt sie.",
  "social.invite.outcome.joined": "Du bist jetzt Mitglied der Gruppe",
  "social.invite.outcome.joinRequested": "Anfrage gesendet. Ein Admin gibt sie frei.",
  "social.invite.outcome.toFriends": "Zu den Freunden",
  "social.invite.outcome.toGroup": "Zur Gruppe",
  "social.code.action": "Du hast einen Code?",
  "social.code.title": "Code eingeben",
  "social.code.hint": "Drei Wörter für eine Einladung, sechs für eine Verkostung.",
  "social.code.placeholder": "z. B. leaf lime loft",
  "social.code.submit": "Weiter",
  "social.code.invalid": "Das ist kein Code. Prüfe die Wörter noch einmal.",
  "social.samen.title": "Gemeinsam",
  "social.samen.badge": "{label}, {count} neu",
  "social.samen.announce": "{count} neu in Gemeinsam",
  "social.samen.profile": "Dein Profil",
  "social.samen.lead": "Deine Freunde, deine Gruppen und was auf dich wartet.",
  "social.inbox.title": "Posteingang",
  "social.inbox.tab.received": "Erhalten",
  "social.inbox.tab.sent": "Gesendet",
  "social.inbox.tab.updates": "Neuigkeiten",
  "social.inbox.empty.received": "Nichts wartet auf dich.",
  "social.inbox.empty.sent": "Du wartest auf niemanden.",
  "social.inbox.empty.updates": "Noch keine Neuigkeiten.",
  "social.inbox.friendRequest": "möchte befreundet sein",
  "social.inbox.groupInvite": "{name} lädt dich in {group} ein",
  "social.inbox.groupInviteAnonymous": "Einladung in {group}",
  "social.inbox.joinRequest": "möchte {group} beitreten",
  "social.inbox.sessionInvite": "{name} lädt dich zu {session} ein",
  "social.inbox.accept": "Annehmen",
  "social.inbox.decline": "Ablehnen",
  "social.inbox.open": "Ansehen",
  "social.inbox.cancel": "Zurückziehen",
  "social.inbox.remind": "Erinnern",
  "social.inbox.reminded": "Erinnert",
  "social.inbox.sent.friendRequest": "Freundschaftsanfrage",
  "social.inbox.sent.groupInvite": "In {group} eingeladen",
  "social.inbox.links.title": "Deine Links",
  "social.inbox.link.friend": "Persönlicher Link",
  "social.inbox.link.group": "Link für {group}",
  "social.inbox.link.ended": "Funktioniert nicht mehr",
  "social.inbox.link.joined": "Dabei waren: {names}",
  "social.inbox.update.friendAccepted": "{name} ist jetzt dein Freund",
  "social.inbox.update.groupInviteAccepted": "{name} ist {group} beigetreten",
  "social.inbox.update.joinApproved": "Du wurdest in {group} aufgenommen",
  "social.inbox.someone": "Jemand",
  "social.inbox.aGroup": "eine Gruppe",
  "social.inbox.queued": "Geht durch, sobald du wieder online bist",
  "social.profile.title": "Profil",
  "social.profile.lead": "So sehen dich andere.",
  "social.profile.noGroups": "Du bist noch in keiner Gruppe.",
  "social.profile.signedOut": "Melde dich an für ein Profil, das deine Freunde sehen.",
  "social.settings.title": "Einstellungen",
  "social.settings.open": "Einstellungen öffnen",
  "social.notify.title": "Benachrichtigungen",
  "social.notify.invites": "Einladungen und Anfragen",
  "social.notify.invites.hint":
    "Eine Benachrichtigung, wenn dich jemand einlädt oder mit dir befreundet sein möchte. Wer angenommen hat, siehst du in deinem Posteingang.",
  "social.notify.quiet": "Ruhezeiten",
  "social.notify.quiet.from": "Von",
  "social.notify.quiet.until": "Bis",
  "social.notify.quiet.hint":
    "In diesen Stunden gibt es keine Benachrichtigungen; alles steht trotzdem in deinem Posteingang. Höchstens {n} Benachrichtigungen pro Tag.",
  "social.notify.mutes.title": "Stummgeschaltet",
  "social.notify.mutes.empty":
    "Niemand stummgeschaltet. Ein stummgeschalteter Freund oder eine stummgeschaltete Gruppe sendet dir keine Benachrichtigungen mehr.",
  "social.notify.mute": "Stummschalten",
  "social.notify.unmute": "Stummschaltung aufheben",
  "social.groups.inviteFriends": "Freunde einladen",
  "social.groups.inviteFriends.sent": "{n} eingeladen. Sie kommen dazu, sobald sie annehmen.",
  "social.groups.inviteLink": "Link teilen",
  "social.groups.log.title": "Protokoll",
  "social.groups.log.empty": "Noch nichts passiert.",
  "social.groups.log.created": "{name} hat die Gruppe angelegt",
  "social.groups.log.joined": "{name} ist beigetreten",
  "social.groups.log.left": "{name} hat die Gruppe verlassen",
  "social.groups.log.removed": "{name} wurde aus der Gruppe entfernt",
  "social.groups.log.role": "{name} ist jetzt {role}",
  "social.groups.mute": "Gruppe stummschalten",
  "social.groups.unmute": "Gruppe nicht mehr stummschalten",
  "social.share.title": "Teilen",
  "social.share.action": "Teilen",
  "social.share.shared": "Geteilt",
  "social.share.copied": "Link kopiert",
  "social.invite.channel.share": "Teilen…",
  "social.inbox.link.reshare": "Erneut teilen",
} as const;
